module.exports = __webpack_public_path__ + "static/media/discover_2.cf29aad9.svg";